import { OPEN_MODE } from './constants.js';

/**
 * Convert a string flag (e.g. 'r', 'w+', 'a') to an SFTP open mode bitmask.
 * Returns null if the flag string is not recognized.
 */
export function stringToFlags(flagsStr: string): number | null {
	switch (flagsStr) {
		case 'r':
			return OPEN_MODE.READ;
		case 'r+':
			return OPEN_MODE.READ | OPEN_MODE.WRITE;
		case 'w':
			return OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.TRUNC;
		case 'wx':
		case 'xw':
			return OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.TRUNC | OPEN_MODE.EXCL;
		case 'w+':
			return OPEN_MODE.READ | OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.TRUNC;
		case 'wx+':
		case 'xw+':
			return OPEN_MODE.READ | OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.TRUNC | OPEN_MODE.EXCL;
		case 'a':
			return OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.APPEND;
		case 'ax':
		case 'xa':
			return OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.APPEND | OPEN_MODE.EXCL;
		case 'a+':
			return OPEN_MODE.READ | OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.APPEND;
		case 'ax+':
		case 'xa+':
			return OPEN_MODE.READ | OPEN_MODE.WRITE | OPEN_MODE.CREAT | OPEN_MODE.APPEND | OPEN_MODE.EXCL;
		default:
			return null;
	}
}

/**
 * Convert an SFTP open mode bitmask to the equivalent string flag.
 * Returns null if the bitmask doesn't map to a known flag combination.
 */
export function flagsToString(flagsMask: number): string | null {
	const { READ, WRITE, APPEND, CREAT, TRUNC, EXCL } = OPEN_MODE;

	// normalize — strip unknown bits
	const f = flagsMask & (READ | WRITE | APPEND | CREAT | TRUNC | EXCL);

	switch (f) {
		case READ:
			return 'r';
		case READ | WRITE:
			return 'r+';
		case WRITE | CREAT | TRUNC:
			return 'w';
		case WRITE | CREAT | TRUNC | EXCL:
			return 'wx';
		case READ | WRITE | CREAT | TRUNC:
			return 'w+';
		case READ | WRITE | CREAT | TRUNC | EXCL:
			return 'wx+';
		case WRITE | CREAT | APPEND:
			return 'a';
		case WRITE | CREAT | APPEND | EXCL:
			return 'ax';
		case READ | WRITE | CREAT | APPEND:
			return 'a+';
		case READ | WRITE | CREAT | APPEND | EXCL:
			return 'ax+';
		default:
			return null;
	}
}
